<script>
export let currentRoute;


import Navbar from 'layouts/Navbar.svelte';



import { Route, navigateTo } from 'svelte-router-spa';
import { onMount } from 'svelte';


const params = {};


</script>


<style>

#layout {
	
}

</style>


<Navbar />
<div id="layout" class="layout">
	<Route {currentRoute} {params} />
</div>


